module.exports = __webpack_public_path__ + "img/2024-08-29c_2.fa4f6936.jpg";